import { createContext, useContext } from 'react';

import { ChildDetails } from '@sola/schema/dotcom/children/child.js';

type RandomChildContextValue = {
  data: Awaited<ChildDetails> | undefined;
  isLoading: boolean;
};

export const RandomChildContext = createContext<RandomChildContextValue | null>(
  null,
);

export const useRandomChild = () => {
  const context = useContext(RandomChildContext);

  if (!context) {
    throw new Error('useRandomChild must be used within a RandomChildProvider');
  }

  return context;
};
